import type { ReactNode } from 'react';
import MarketingLayout from './MarketingLayout';

interface PublicLayoutProps {
  children: ReactNode;
  mode?: 'sign-in' | 'sign-up' | 'profile';
}

export default function PublicLayout({ children, mode = 'profile' }: PublicLayoutProps) {
  const signingUp = mode === 'sign-up';
  return (
    <MarketingLayout mainClassName="public-auth-main">
      <div className="public-auth-intro">
        <p className="public-eyebrow">Your strategy starts here</p>
        <h1>
          {signingUp
            ? 'Give your ambition a clear plan.'
            : mode === 'sign-in'
              ? 'Pick up where your strategy left off.'
              : 'Your account. Your workspace.'}
        </h1>
        <p>
          {signingUp
            ? 'Bring your direction, priorities, people and projects together. Create your account to start building a strategy you can put to work.'
            : mode === 'sign-in'
              ? 'Your company context, strategic decisions and next steps, together in one connected workspace.'
              : 'Manage the details that keep your strategy connected.'}
        </p>
        <img
          src="/images/homepage/strategy-workspace.png"
          alt="Illustrative connected strategy workspace with objectives, projects and AI assistance"
        />
      </div>
      <div className="public-auth-panel">{children}</div>
    </MarketingLayout>
  );
}
